/**
 * @license
 * Copyright Akveo. All Rights Reserved.
 * Licensed under the MIT License. See License.txt in the project root for license information.
 */
export const environment = {
	production: true,
	serverUrl: 'https://path-api-crm.globalmediaoutreach.com',
	socket_end_point: 'https://path-api-socket.globalmediaoutreach.com',
	notificationServerUrl: 'https://path-api-socket.globalmediaoutreach.com',
	bibleApiKey: 'ea1d558ae3ab1fa8bc7aed6e2145d489',
	pathFormApiUrl: 'https://path-api-widget.globalmediaoutreach.com/',
	mobileAppUrl: 'https://path.globalmediaoutreach.com/',
};
